import axios from 'axios';
const baseUrlFlow = process.env.REACT_APP_AWS_API_GATEWAY_URL_EXECUTE_FLOW;

// export const sendRequest = (obj, accessToken) => {
//     return axios({
//         method: "POST",
//         url: baseUrlFlow,
//         headers: {
//             'Authorization': `Bearer ${accessToken}`,
//             'Content-Type': 'application/json'
//         },
//         data: JSON.stringify(obj)
//     });
// };

export const sendRequest = async (accessToken, payload) => {
    return axios.post(baseUrlFlow, JSON.stringify(payload), {
        headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        }
    });
};